import { inject } from "@angular/core";
import { CanActivateFn, Router } from "@angular/router";
import { AUTH_SVC } from "@company-box/services";
import { LoginModalService } from "../services/login-modal.service";

/**
 * Guards account-area routes. Logged-in users pass through; logged-out users are
 * redirected home and shown the login modal, then routed back to where they were
 * heading once they authenticate. This keeps account pages from rendering with
 * failed (unauthenticated) API calls.
 */
export const requireCustomerLogin: CanActivateFn = (_route, state) => {
  const authService = inject(AUTH_SVC);
  const loginModal = inject(LoginModalService);
  const router = inject(Router);

  if (authService.getToken()?.accessToken) {
    return true;
  }

  loginModal.open(state.url);
  return router.parseUrl("/start");
};
